import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectSection, customiseProduct } from '../actions';

/**
 * History listener component
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
class History extends Component {
    constructor(props) {
        super(props);

        this.justPopped = false;
        this.onPopState = this.onPopState.bind(this);

        window.addEventListener('popstate', this.onPopState);
    }

    onPopState(e) {
        this.justPopped = true;

        // don't do anything if we've finished
        if (this.props.finished) {
            return;
        }

        // no state? go back to the start page
        if (e.state === null) {
            this.props.dispatch(selectSection(''));
            return;
        }

        // need to work out what event to send based upon the passed state
        const { category, product, section } = e.state;

        if (product) {
            this.props.dispatch(customiseProduct(product));
        } else if (section) {
            this.props.dispatch(selectSection(section));
        }
    }

    componentWillReceiveProps(nextProps) {
        const { category, product, section } = this.props;

        // has anything changed?
        if (nextProps.category === category && nextProps.product === product && nextProps.section === section) {
            return;
        }

        // don't re-add a just-popped state
        if (this.justPopped) {
            this.justPopped = false;
            return;
        }

        let newState = {
            category: nextProps.category,
            product: nextProps.product,
            section: nextProps.section,
        };

        window.history.pushState(newState, `${process.env.MIX_REACT_APP_NAME}-${process.env.MIX_REACT_APP_VERSION}`);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.onPopState);
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    finished: state.finished,
    category: state.browser.selectedCategory,
    product: state.browser.selectedProduct,
    section: state.navigation.selected,
});

export default connect(mapStateToProps)(History);
